// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataeurc } from "../../../icons/mono/build/icon-stataeurc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataeurcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataeurc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataeurcIcon.displayName = 'StataeurcIcon';
}

export default StataeurcIcon;